// extracted by mini-css-extract-plugin
export default {"container":"NoteForm_container__vLate","icon":"NoteForm_icon__XU6aG","title-input-container":"NoteForm_title-input-container__9owMI","submit-button":"NoteForm_submit-button__2RD+e"};